import React, { useState, useEffect } from 'react'
import {
  Label,
  FormGroup
} from 'reactstrap'
import Moment from 'moment'
import ReactHTMLParser from 'react-html-parser'
import Datepicker from 'components/Datepicker'

import _ from 'lodash'

const DateField = ({
  content,
  formValues,
  onPatchFormFormValues,
  currentLanguage
}) => {
  const [labelStr, setLabelStr] = useState("")
  const [ isValidFormValue, setIsValidFormValue ] = useState( false )

  useEffect( () => {
    let dateValue = _.cloneDeep( formValues[ content.dataMapIndex ][ 'value' ] )
    if( !_.isEmpty( dateValue ) && Moment( dateValue ).isValid() ) {
      onPatchFormFormValues( content.dataMapIndex, 'value', new Date( dateValue ) )
    } else {
      onPatchFormFormValues( content.dataMapIndex, 'value', '' )
    }
    setIsValidFormValue( true )
  }, [] )

  useEffect(() => {
    let labelText = content.label[ currentLanguage ? currentLanguage : 'en' ]

    if (labelText.length !== 0) {
      if (typeof(ReactHTMLParser( labelText )[0]) === 'object') {
        let labelTag = ReactHTMLParser( labelText )[0].type
        let closingTag = "</" + labelTag + ">"
        labelText = labelText.slice(0, -1*closingTag.length)
        if (formValues[ content.dataMapIndex ][ 'isRequired' ])
          labelText = labelText + "<span style='color: #ff0000;'> * </span>"
        labelText = labelText + closingTag
      }
      else {
        labelText = labelText + "<span style='color: #ff0000;'> * </span>"
      }
    }
    setLabelStr(labelText)
  }, [content, formValues, currentLanguage])

  return(
    <FormGroup 
      id={ content.id } 
      style={{ padding: content.padding, marginBottom: 0 }}>
      <Label style={{ fontSize: content.fontSize }} >{ ReactHTMLParser( labelStr ) }</Label>
      {
        isValidFormValue && (
          <Datepicker
            selectedDate={ formValues[ content.dataMapIndex ][ 'value' ] }
            dateFormat='dd/MM/yyyy'
            onChange={ val => onPatchFormFormValues( content.dataMapIndex, 'value', val ) }
            placeholderText={ 'dd/mm/yyyy' } />
        )
      }
    </FormGroup>
  )
}

export default DateField